<template>
  <v-footer
  height="auto"
  color="primary"
  >
    <v-container
      fluid>
      <v-row
        justify=center
        >
        <v-btn
          class="main--text font-weight-bold"
          v-for="(link, index) in links"
          :key="index"
          color="white"
          text
          rounded
          @click="$router.push({path: link.path})"
          >
          {{ link.title }}
        </v-btn>
        <v-btn
          class="main--text font-weight-bold"
          color="white"
          text
          rounded
          href="https://stemed.tk"
          >BLOG
        </v-btn>
      </v-row>
      <v-row
        justify=space-between>
        <v-col
          py-3
          class=white--text
          cols=12
          sm=auto
          >
          &copy;2019 — <strong>Prosense</strong>
        </v-col>
        <v-sns-icons></v-sns-icons>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import VSnsIcons from "@/components/molecules/VSnsIcons.vue"
export default {
  components: {
    VSnsIcons
  },
  data () {
    return {
      links: [
        { title: 'Home', path: '/'},
        // { title: 'About Us', path: '/'},
        // { title: 'Team', path: '/'},
        // { title: 'Services', path: '/'},
        { title: 'お問い合わせ', path: '/contact'},
        { title: 'プライバシーポリシー', path: '/policy'}
      ]
    }
  }
}
</script>

<style scoped>
.sns-icon {
  padding: 0px 5px;
}
</style>
